<script>
import PrincipalHeader from "@/views/pages/dashboard/principal/components/Principal-header.vue";
import PrincipalSidebar from "@/views/pages/dashboard/principal/components/Principal-sidebar.vue";
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";
import { useAccessClassRequestStore } from "@/stores/access/access-class-request-store";
import { useAuthStore } from "@/stores/auth-store";
import AccessDialogApprove from "@/components/CustomComponent/modal/access-dialog-approve.vue";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";

export default {
  components: {
    PrincipalHeader,
    PrincipalSidebar,
    BaseLoading,
    AccessDialogApprove,
  },
  data() {
    return {
      sharedStore: null,
      accessClassRequestStore: null,
      authStore: null,
    };
  },
  created() {
    this.sharedStore = useSharedStore();
    this.accessClassRequestStore = useAccessClassRequestStore();
    this.authStore = useAuthStore();
  },

  async mounted() {
    await this.accessClassRequestStore.fetchAccessRequests();
  },
  methods: {
    approveRequest(id) {
      this.accessClassRequestStore.approveAccessID = id;

      const modalEl = document.getElementById("approveAccessModal");
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      modal.show();
    },
    async rejectRequest(id) {
      const result = await Swal.fire({
        title: "Tolak Request?",
        text: "Apakah kamu yakin ingin menolak class access request ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Tolak",
        cancelButtonText: "Batal",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      });

      if (result.isConfirmed) {
        this.accessClassRequestStore.rejectAccessID = id;
        try {
          await this.accessClassRequestStore.rejectAccessRequest();
        } catch (error) {
          console.error("Gagal reject access request:", error);
          Swal.fire("Error", "Terjadi kesalahan saat menolak.", "error");
        }
      }
    },
  },
};
</script>
<template>
  <!-- {{ console.log(accessClassRequestStore.classRequestList) }} -->
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">Dashboard</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Dashboard
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->
  <div class="content">
    <div class="container">
      <PrincipalHeader></PrincipalHeader>
      <div class="row">
        <PrincipalSidebar></PrincipalSidebar>
        <div class="col-lg-9">
          <div class="row">
            <div>
              <div
                class="page-title d-flex align-items-center justify-content-between"
              >
                <h5 class="fw-bold">Class Access Request</h5>
              </div>
              <div
                class="border rounded-2 p-4 mb-3 text-center"
                v-if="accessClassRequestStore.pendingRequests.length === 0"
              >
                <div class="d-inline-flex icon-box bg-soft-info mb-3">
                  <img src="@/assets/img/icon/user-tick.svg" alt="" />
                </div>
                <h6 class="mb-1">No Pending Access Requests</h6>
                <p class="mb-0 fs-14 text-gray-5">
                  Class access requests from students will appear here when they
                  need your approval.
                </p>
              </div>
              <div
                class="border rounded-2 p-3 mb-3"
                v-for="(
                  item, index
                ) in accessClassRequestStore.pendingRequests"
                :key="index"
              >
                <div class="row align-items-center">
                  <div class="col-md-8">
                    <div>
                      <h6 class="mb-2">
                        {{ item.course.title }}
                      </h6>
                      <div class="question-info d-flex align-items-center">
                        <p
                          class="d-flex align-items-center fs-14 me-2 pe-2 border-end mb-0"
                        >
                          <i
                            class="isax isax-message-question5 text-primary-soft me-2"
                          ></i
                          >Request By: {{ authStore.userName(item.studentID) }}
                        </p>
                        <p class="d-flex align-items-center fs-14 mb-0">
                          <img src="@/assets/img/icon/icon-22.svg" alt="" />{{
                            sharedStore.formatTanggal(item.created_at)
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div
                      class="d-flex align-items-center justify-content-end mt-2 mt-md-0"
                    >
                      <a
                        href="#"
                        class="d-inline-flex fs-14 me-1 action-icon"
                        title="Approve"
                        @click.prevent="approveRequest(item.requestID)"
                        ><img src="@/assets/img/icon/check-circle.svg" alt=""
                      /></a>
                      <a
                        href="#"
                        class="d-inline-flex fs-14 action-icon"
                        title="Reject"
                        @click.prevent="rejectRequest(item.requestID)"
                        ><img src="@/assets/img/icon/close-circle.svg" alt=""
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <BaseLoading v-show="sharedStore.loading"></BaseLoading>
  <AccessDialogApprove />
</template>
